var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandlineGridDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 8,
    height: 8,
    rx: 4,
    fill: "#e67e22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandlineGridDotIcon);
export default __webpack_public_path__ + "static/media/landline-grid-dot-icon.239a3480a86f5d9410f30ac7b1c22e52.svg";
export { ForwardRef as ReactComponent };